import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Form } from "./Form";
import useToggle from "../../hooks/useToggle";
import { IDepartment } from "../../models/BaseModel";
import { Table } from "./Table";

export interface IOpenForm {
    open: boolean,
    singleData: IDepartment
}

export const ImageGallery = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false })
    };

    return (
        <>
            <Form hasPermission={hasPermission} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
